module.exports = __webpack_public_path__ + "img/Verwirbelung.ceea5c99.jpg";